import AIFormDrawer from "Pages/Patient/AIFormHistory/AIFormDrawer";
import { Card } from "antd";
import React from "react";
// import AIFormDrawer from "./AIFormDrawer";

function ChimeSpeechToAIForm(props) {
  return (
    <div
      className="chimeSpeechToAIForm"
      style={{
        // height:"calc(80vh + 24px)",
        // display: props.is_show_ai_form ? "grid" : "none",
        // display:"none"
      }}
      // title={"title"}
      // actions={["actions"]}
    >
      <AIFormDrawer {...props} chime_enabled={true} is_editable={true}/>
    </div>
  );
}

export default ChimeSpeechToAIForm;
